import { formatDate } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'resultDate',
})
export class ResultDatePipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) private localeId: string) {}

    transform(value: string | Date | number, dateFormatDate?: string, dateFormatTime?: string): string {
        if (!value) {
            return '';
        }
        try {
            let dateObj = new Date(value);
            if (typeof value === 'string') {
                // Attempt to parse the input value as a date string to avoid Invalid date error
                dateObj = new Date(value);
                if (isNaN(dateObj.getTime())) {
                    return '';
                }
            } else {
                dateObj = new Date(value);
            }

            const datePart = dateFormatDate ? this.formatDate(dateObj, dateFormatDate) : this.formatDate(dateObj, 'dd.MM.yyyy');
            const timePart = dateFormatTime ? ` | ${formatDate(dateObj, dateFormatTime, this.localeId)}` : '';

            return `${datePart}${timePart}`;
        } catch (err) {
            console.error(err);
            return '';
        }
    }

    private formatDate(date: Date, dateFormatDate: string): string {
        const now = new Date();
        if (date.getTime() + 86400000 > now.getTime()) {
            return date.getDay() === now.getDay() ? 'Today' : 'Yesterday';
        } else if (date.getTime() + 172800000 > now.getTime()) {
            return date.getDay() + 1 === now.getDay() || (date.getDay() === 6 && now.getDay() === 0) ? 'Yesterday' : this.getDateString(date, dateFormatDate);
        } else {
            return this.getDateString(date, dateFormatDate);
        }
    }

    private getDateString(date: Date, format: string): string {
        try {
            return formatDate(date, format, this.localeId);
        } catch (err) {
            console.error(err);
            return '';
        }
    }
}
